"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7072],{

/***/ 79242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10278);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 0px 40px 40px 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: disc !important;\n  margin-left: 30px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var PersonalInfoCollection = function(param) {
    var kind = param.kind;
    var CONTENT = [
        {
            id: 1,
            title: "개인정보 수집 및 이용 목적",
            children: [
                "상담 서비스 이행(상담 신청, 해피콜, 상담 매장 및 영업사원 배정)",
                "제품 상담 및 견적 서비스 제공",
                "제품 설치",
                "고객 상담 서비스 제공",
                "이벤트 참여 안내 및 당첨자 연락, 사은품 배송, 본인 확인 ", 
            ]
        },
        {
            id: 2,
            title: "수집 항목",
            children: [
                "이름, 휴대폰 번호, 주소",
                "상담에 필요한 현장 공사 정보"
            ]
        },
        {
            id: 3,
            title: "보유 및 이용 기간",
            children: kind === "quick" ? [
                "회원: 회원 탈퇴 시 까지",
                "비회원: 서비스 종료 후 1년"
            ] : [
                "회원 탈퇴 시 까지"
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextDefault, {
                children: "상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 수집\xb7이용하고자 합니다. 내용을 자세히 읽으신 후 동의해 주시기 바랍니다. 이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다. 단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다. 그 밖의 사항은 (주)한샘 개인정보처리 방침에 따릅니다."
            }),
            CONTENT.map(function(item) {
                return item.id < 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextDefault, {
                    children: [
                        "".concat(item.id, ".  ").concat(item.title),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
                            children: item.children.map(function(val, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListITtem, {
                                    children: val
                                }, idx);
                            })
                        })
                    ]
                }, item.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextBold, {
                    children: [
                        "".concat(item.id, ".  ").concat(item.title),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
                            children: item.children.map(function(val, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListITtem, {
                                    children: val
                                }, idx);
                            })
                        })
                    ]
                }, item.id);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PersonalInfoCollection);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PersonalInfoCollection__Container",
    componentId: "sc-16097126-0"
})(_templateObject());
var TextDefault = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PersonalInfoCollection__TextDefault",
    componentId: "sc-16097126-1"
})(_templateObject1(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.neutral_colors.gray[700] */ .rS.colors.neutral_colors.gray[700], _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.typography.body2 */ .rS.typography.body2);
var TextBold = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PersonalInfoCollection__TextBold",
    componentId: "sc-16097126-2"
})(_templateObject2(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.accent_colors.primary["default"] */ .rS.colors.accent_colors.primary["default"], _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.typography.subtitle5 */ .rS.typography.subtitle5);
var List = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "PersonalInfoCollection__List",
    componentId: "sc-16097126-3"
})(_templateObject3());
var ListITtem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "PersonalInfoCollection__ListITtem",
    componentId: "sc-16097126-4"
})(_templateObject4());


/***/ }),

/***/ 96411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10278);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 0px 40px 40px 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: disc !important;\n  margin-left: 30px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var ThirdParties = function(param) {
    var kind = param.kind;
    var CONTENT = [
        {
            id: 1,
            title: "제공받는 자 : 한샘 대리점, 한샘 제휴점",
            children: []
        },
        {
            id: 2,
            title: "제공 목적",
            children: [
                "상담 서비스 이행, 제품 상담 및 견적 서비스 제공",
                "제품 설치- 고객 상담 서비스 제공", 
            ]
        },
        {
            id: 3,
            title: "제공 항목",
            children: [
                "이름, 휴대폰 번호, 주소",
                "상담에 필요한 현장 공사 정보"
            ]
        },
        {
            id: 4,
            title: "보유 및 이용 기간",
            children: kind === "quick" ? [
                "회원: 회원 탈퇴 시 까지",
                "비회원: 서비스 종료 후 1년"
            ] : [
                "회원 탈퇴 시 까지"
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextDefault, {
                children: "상담 예약 서비스 제공을 위해 아래와 같이 개인정보를 제3자에게 제공하고자 합니다. 내용을 자세히 읽으신 후 동의해 주시기 바랍니다. 이용자가 동의한 내용 외의 다른 목적으로 사용하지 않으며, 이용자는 동의를 거부할 권리가 있습니다. 단, 동의 거부 시 상담신청 서비스를 받으실 수 없습니다. 그 밖의 사항은 (주) 한샘 개인정보처리 방침에 따릅니다."
            }),
            CONTENT.map(function(item) {
                return item.id === 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextDefault, {
                    children: [
                        "".concat(item.id, ".  ").concat(item.title),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
                            children: item.children.map(function(val, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListITtem, {
                                    children: val
                                }, idx);
                            })
                        })
                    ]
                }, item.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextBold, {
                    children: [
                        "".concat(item.id, ".  ").concat(item.title),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
                            children: item.children.map(function(val, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListITtem, {
                                    children: val
                                }, idx);
                            })
                        })
                    ]
                }, item.id);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ThirdParties);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ThirdParties__Container",
    componentId: "sc-bdda6d7f-0"
})(_templateObject());
var TextDefault = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ThirdParties__TextDefault",
    componentId: "sc-bdda6d7f-1"
})(_templateObject1(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.neutral_colors.gray[700] */ .rS.colors.neutral_colors.gray[700], _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.typography.body2 */ .rS.typography.body2);
var TextBold = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ThirdParties__TextBold",
    componentId: "sc-bdda6d7f-2"
})(_templateObject2(), _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.accent_colors.primary["default"] */ .rS.colors.accent_colors.primary["default"], _styles__WEBPACK_IMPORTED_MODULE_1__/* .theme.typography.subtitle5 */ .rS.typography.subtitle5);
var List = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "ThirdParties__List",
    componentId: "sc-bdda6d7f-3"
})(_templateObject3());
var ListITtem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "ThirdParties__ListITtem",
    componentId: "sc-bdda6d7f-4"
})(_templateObject4());


/***/ }),

/***/ 97119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LoadImage_LoadImage; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/image.js
var next_image = __webpack_require__(30257);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../.yarn/cache/react-merge-refs-npm-2.0.1-e038520c6a-c0b6fdb384.zip/node_modules/react-merge-refs/dist/index.mjs
var dist = __webpack_require__(56467);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-e325f5b003/0/cache/@design-system-pc-npm-4.9.4-1fa44413c9-3660566693.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(33025);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/components/LoadImage/LoadImage.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    height: 100%;\n    object-fit: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







/**
 * 이미지가 로드가 완료된 이후에 노출
 * @author 이현우
 */ var LoadImage = /*#__PURE__*/ react.forwardRef(function LoadImage(_param, ref) {
    var src = _param.src, w = _param.w, h = _param.h, q = _param.q, c = _param.c, className = _param.className, _isNextImage = _param.isNextImage, isNextImage = _isNextImage === void 0 ? false : _isNextImage, _imgFit = _param.imgFit, imgFit = _imgFit === void 0 ? "fill" : _imgFit, objectFit = _param.objectFit, _imageScale = _param.imageScale, imageScale = _imageScale === void 0 ? 1 : _imageScale, _skeletonSize = _param.skeletonSize, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 0 : _borderRadius, props = _objectWithoutProperties(_param, [
        "src",
        "w",
        "h",
        "q",
        "c",
        "className",
        "isNextImage",
        "imgFit",
        "objectFit",
        "imageScale",
        "skeletonSize",
        "borderRadius"
    ]);
    var imageRef = (0,react.useRef)(null);
    var wrapperRef = (0,react.useRef)(null);
    var mergeRef = (0,dist/* mergeRefs */.l)([
        ref,
        imageRef
    ]);
    var _$ref = (0,react.useState)(null), aspectRatio = _$ref[0], setAspectRatio = _$ref[1];
    var _$ref1 = (0,react.useState)(false), imageLoaded = _$ref1[0], setImageLoaded = _$ref1[1];
    var handleChangeMeta = (0,react.useCallback)(function() {
        var _$ref, _$ref1, _$ref2;
        if ((imageRef === null || imageRef === void 0 ? void 0 : (_$ref = imageRef.current) === null || _$ref === void 0 ? void 0 : _$ref.naturalWidth) != null && (imageRef === null || imageRef === void 0 ? void 0 : (_$ref1 = imageRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.naturalHeight) != null) props === null || props === void 0 ? void 0 : (_$ref2 = props.handleChangeMeta) === null || _$ref2 === void 0 ? void 0 : _$ref2.call(props, {
            width: imageRef.current.naturalWidth,
            height: imageRef.current.naturalHeight
        });
    }, [
        props
    ]);
    var updateLoadedState = (0,react.useCallback)(function() {
        setImageLoaded(true);
        handleChangeMeta();
    }, [
        handleChangeMeta
    ]);
    var handleImageLoaded = (0,react.useCallback)(function(result) {
        var _$ref;
        if (result.naturalWidth && result.naturalHeight) {
            setAspectRatio(result.naturalWidth / result.naturalHeight);
        }
        updateLoadedState();
        props === null || props === void 0 ? void 0 : (_$ref = props.onLoad) === null || _$ref === void 0 ? void 0 : _$ref.call(props, _objectSpreadProps(_objectSpread({}, result), {
            target: imageRef.current
        }));
    }, [
        props,
        updateLoadedState
    ]);
    var handleImageError = (0,react.useCallback)(function(e) {
        var _$ref;
        props === null || props === void 0 ? void 0 : (_$ref = props.onError) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
    }, [
        props
    ]);
    var alreadyLoadedImageUpdateState = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var _$ref, _$ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!imageLoaded && (imageRef === null || imageRef === void 0 ? void 0 : (_$ref = imageRef.current) === null || _$ref === void 0 ? void 0 : _$ref.complete)) {
                        ;
                        updateLoadedState();
                        props === null || props === void 0 ? void 0 : (_$ref1 = props.onLoad) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(props, {
                            status: "alreadyLoaded"
                        });
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        imageLoaded,
        props,
        updateLoadedState
    ]);
    var calculateDimensions = (0,react.useCallback)(function() {
        if (!aspectRatio) return {};
        // w만 주어진 경우
        if (w && !h) {
            return {
                width: w,
                height: Math.round(w / aspectRatio)
            };
        }
        // h만 주어진 경우
        if (!w && h) {
            return {
                width: Math.round(h * aspectRatio),
                height: h
            };
        }
        // w, h 모두 주어진 경우 그대로 반환
        return {
            width: w,
            height: h
        };
    }, [
        w,
        h,
        aspectRatio
    ]);
    var dimensions = calculateDimensions();
    var imageUrl = (0,utils/* getResizeImage */.uU)({
        url: src && typeof src === "string" ? src : "",
        w: w ? w * imageScale : w,
        h: h ? h * imageScale : h,
        q: q,
        c: c
    });
    // next/image의 13.0.6 이전 버전은 ref를 지원하지 않기 때문에 수동으로 ref처리
    (0,react.useEffect)(function() {
        if (wrapperRef.current) {
            var imgElement = wrapperRef.current.querySelector("img");
            if (imgElement) {
                mergeRef(imgElement);
            }
        }
    }, [
        mergeRef,
        src
    ]);
    (0,react.useEffect)(function() {
        alreadyLoadedImageUpdateState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isNextImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
            position: "relative",
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                ref: wrapperRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), _objectSpreadProps(_objectSpread({}, props), {
                    src: imageUrl,
                    width: dimensions.width,
                    height: dimensions.height,
                    className: className,
                    objectFit: objectFit,
                    layout: imgFit,
                    alt: props.alt || "",
                    style: {
                        borderRadius: "".concat(borderRadius, "px")
                    },
                    onLoadingComplete: handleImageLoaded,
                    onError: handleImageError,
                    unoptimized: true
                }))
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemorizedStyledImage, _objectSpread({
                ref: mergeRef,
                src: imageUrl,
                alt: props.alt || "",
                objectFit: objectFit,
                className: className,
                style: {
                    borderRadius: "".concat(borderRadius, "px")
                },
                onError: handleImageError
            }, props))
        })
    });
});
/* harmony default export */ var LoadImage_LoadImage = (LoadImage);
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "LoadImage__StyledImage",
    componentId: "sc-a1dd7391-0"
})(_templateObject1(), function(param) {
    var objectFit = param.objectFit;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), objectFit || "cover");
});
var MemorizedStyledImage = /*#__PURE__*/ (0,react.memo)(StyledImage);

;// CONCATENATED MODULE: ./src/components/LoadImage/index.tsx
/* 작성자 : 이현우 */ 



/***/ }),

/***/ 20838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ expertGateway; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24721);
/* harmony import */ var _remodeling_shop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83651);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}




var expertGateway = function() {
    return {
        getExpertDetail: new ClientGetExpertDetailGateway(_di_container_axios__WEBPACK_IMPORTED_MODULE_1__/* .axios */ .o),
        getExpertDetailReview: new _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__/* .GetExpertDetailReviewGateway */ .Fr(_di_container_axios__WEBPACK_IMPORTED_MODULE_1__/* .axios */ .o),
        getRdStatistics: new _remodeling_goods__WEBPACK_IMPORTED_MODULE_2__/* .GetRdStatisticsGateway */ .Q3(_di_container_axios__WEBPACK_IMPORTED_MODULE_1__/* .axios */ .o)
    };
};
var ClientGetExpertDetailGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetExpertDetailGateway(httpClient) {
        _classCallCheck(this, ClientGetExpertDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetExpertDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var apiResponse;
            return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new _remodeling_shop__WEBPACK_IMPORTED_MODULE_3__/* .GetAgentDetailGateway */ .sK(_this.httpClient).exec(req);
                    case 2:
                        apiResponse = _ctx.sent;
                        return _ctx.abrupt("return", apiResponse);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetExpertDetailGateway;
}();


/***/ }),

/***/ 17881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ quickConsultGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31376);


var quickConsultGateway = function() {
    return {
        getBasic: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetQuickConsultBasicInfoGateway */ .lx(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getChannel: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetQuickConsultChannelInfoGateway */ .k4(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        createQuickConsult: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .CreateQuickConsultGateway */ .w_(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getDetail: new _remodeling_remodeling_manager__WEBPACK_IMPORTED_MODULE_1__/* .GetQuickConsultDetailGateway */ .UA(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 55806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useDataLayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _hooks_useEffectOnce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87026);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var useDataLayer = function(effect) {
    var remainEffect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    var has = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var key = param.key, value = param.value;
        var ref, ref1;
        if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(value)) return window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.some(function(item) {
            return lodash__WEBPACK_IMPORTED_MODULE_2___default().has(item, key);
        });
        return window === null || window === void 0 ? void 0 : (ref1 = window.dataLayer) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return (item === null || item === void 0 ? void 0 : item[key]) === value;
        });
    }, []);
    var handlePush = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var data = param.data, key = param.key;
        var // if (has({ key, value: data[key] })) return;
        ref;
        if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data[key])) return;
        window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push(_objectSpread({}, data));
    }, []);
    var handleRemove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var key = param.key, value = param.value;
        var ref;
        if (!has({
            key: key,
            value: value
        })) return;
        var index = window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.findIndex(function(item) {
            return (item === null || item === void 0 ? void 0 : item[key]) === value;
        });
        window.dataLayer.splice(index, 1);
    }, [
        has
    ]);
    var handlePushAndRemove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var data = param.data, key = param.key;
        handlePush({
            data: data,
            key: key
        });
    // handleRemove({ key, value: data[key] });
    }, [
        handlePush
    ]);
    var isContainerLoad = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var ref, ref1, ref2;
        return (ref = window) === null || ref === void 0 ? void 0 : (ref1 = ref.google_tag_manager) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataLayer) === null || ref2 === void 0 ? void 0 : ref2.gtmLoad;
    }, []);
    (0,_hooks_useEffectOnce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var remainEffectHandler = function() {
            if (remainEffect.current) {
                remainEffect.current = false;
                return effect === null || effect === void 0 ? void 0 : effect({
                    handlePush: handlePush,
                    handleRemove: handleRemove,
                    has: has,
                    handlePushAndRemove: handlePushAndRemove
                });
            }
        };
        window.addEventListener("load", remainEffectHandler);
        var destroyFunc;
        if (isContainerLoad()) {
            destroyFunc = remainEffectHandler();
        }
        return function() {
            destroyFunc === null || destroyFunc === void 0 ? void 0 : destroyFunc();
            window.removeEventListener("load", remainEffectHandler);
        };
    });
    return {
        handlePush: handlePush,
        handleRemove: handleRemove,
        has: has,
        handlePushAndRemove: handlePushAndRemove
    };
};


/***/ }),

/***/ 87026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);

/**
 * @author 이현우
 * effect 이벤트가 한번만 일어나게 처리하는 hook
 * @param effect
 */ var useEffectOnce = function(effect) {
    var destroyFunc = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var effectCalled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var renderAfterCalled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // eslint-disable-next-line no-unused-vars
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), _ = ref[0], setVal = ref[1];
    if (effectCalled.current) {
        renderAfterCalled.current = true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!effectCalled.current) {
            destroyFunc.current = effect();
            effectCalled.current = true;
        }
        setVal(function(val) {
            return val + 1;
        });
        return function() {
            if (!renderAfterCalled.current) {
                return;
            }
            if (destroyFunc.current) {
                destroyFunc.current();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useEffectOnce);


/***/ }),

/***/ 93744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Flag_Flag; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/ui/Flag/Flag.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  /* common */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 2px;\n  width: ",
        ";\n  height: ",
        ";\n  min-width: ",
        ";\n  min-height: ",
        ";\n  color: ",
        ";\n  ",
        ";\n\n  /* flag color style */\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function Flag(param) {
    var flagColor = param.flagColor, _width = param.width, width = _width === void 0 ? "54px" : _width, _height = param.height, height = _height === void 0 ? "21px" : _height, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagWrap, {
        flagColor: flagColor,
        width: width,
        height: height,
        children: children
    });
}
var flagColors = {
    red: styles/* theme.colors.accent_colors.red.light */.rS.colors.accent_colors.red.light,
    yellow: styles/* theme.colors.accent_colors.yellow.light */.rS.colors.accent_colors.yellow.light,
    blue: styles/* theme.colors.accent_colors.blue.light */.rS.colors.accent_colors.blue.light,
    mono: styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]
};
var flagColorStyle = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), function(param) {
    var flagColor = param.flagColor;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), flagColors[flagColor]);
});
var FlagWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Flag__FlagWrap",
    componentId: "sc-ea11a474-0"
})(_templateObject2(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.caption1 */.rS.typography.caption1, flagColorStyle);
/* harmony default export */ var Flag_Flag = (Flag);

;// CONCATENATED MODULE: ./src/ui/Flag/index.ts



/***/ }),

/***/ 93478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchAddress_SearchAddress; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
// EXTERNAL MODULE: ./src/ui/BoardPagination/index.ts + 6 modules
var BoardPagination = __webpack_require__(35262);
;// CONCATENATED MODULE: ./src/ui/Icons/SearchDelete16Icon.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function SearchDelete16Icon(props) {
    var _fill, _stroke;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", _objectSpreadProps(_objectSpread({}, props), {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7.5",
                fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#E2E2E2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.771 10.4746C9.96626 10.6699 10.2828 10.6699 10.4781 10.4746C10.6734 10.2793 10.6734 9.96277 10.4781 9.7675L8.70861 7.99801L10.4741 6.2325C10.6694 6.03724 10.6694 5.72065 10.4741 5.52539C10.2789 5.33013 9.96228 5.33013 9.76702 5.52539L8.00151 7.2909L6.23546 5.52486C6.0402 5.3296 5.72362 5.3296 5.52836 5.52486C5.3331 5.72013 5.3331 6.03671 5.52836 6.23197L7.2944 7.99801L5.52438 9.76803C5.32911 9.9633 5.32911 10.2799 5.52438 10.4751C5.71964 10.6704 6.03622 10.6704 6.23148 10.4751L8.00151 8.70512L9.771 10.4746Z",
                fill: (_stroke = props.stroke) !== null && _stroke !== void 0 ? _stroke : "#666666"
            })
        ]
    }));
}
/* harmony default export */ var Icons_SearchDelete16Icon = (SearchDelete16Icon);

;// CONCATENATED MODULE: ./src/ui/Icons/TopbarSearchIcon.tsx


function TopbarSearchIcon(props) {
    var _boxSize, _boxSize1, _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "32",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.5 14.5C20.5 18.0899 17.5899 21 14 21C10.4101 21 7.5 18.0899 7.5 14.5C7.5 10.9101 10.4101 8 14 8C17.5899 8 20.5 10.9101 20.5 14.5ZM19.1018 20.6624C17.717 21.8101 15.9391 22.5 14 22.5C9.58172 22.5 6 18.9183 6 14.5C6 10.0817 9.58172 6.5 14 6.5C18.4183 6.5 22 10.0817 22 14.5C22 16.4391 21.3101 18.217 20.1624 19.6018L25.0303 24.4697C25.3232 24.7626 25.3232 25.2374 25.0303 25.5303C24.7374 25.8232 24.2626 25.8232 23.9697 25.5303L19.1018 20.6624Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
        })
    });
}
/* harmony default export */ var Icons_TopbarSearchIcon = (TopbarSearchIcon);

// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
;// CONCATENATED MODULE: ./src/ui/SearchAddress/SearchAddressNoti.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  width: 490px;\n  height: 230px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 6px;\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 100%;\n  background-color: ",
        ";\n  width: 2px;\n  height: 2px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




function SearchAddressNoti() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchAddressNotiWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "Tip"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: "아래와 같은 방법으로 검색해 보세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TipWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tip, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Bullet, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "도로명 + 건물번호"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Example, {
                                children: "예) 성암로 179, 방배로 285"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tip, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Bullet, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "지역명(동/리) + 번지"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Example, {
                                children: "예) 상암동 1623, 방배동 757"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tip, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Bullet, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "지역명(동/리) + 건물명(아파트명)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Example, {
                                children: "예) 상암동 한샘상암, 방배동 한샘빌딩"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var SearchAddressNotiWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__SearchAddressNotiWrap",
    componentId: "sc-e0cbc8e8-0"
})(_templateObject(), styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50]);
var TitleWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__TitleWrap",
    componentId: "sc-e0cbc8e8-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__Title",
    componentId: "sc-e0cbc8e8-2"
})(_templateObject2(), styles/* theme.typography.button.lg_b */.rS.typography.button.lg_b, styles/* theme.colors.accent_colors.red.default */.rS.colors.accent_colors.red["default"]);
var Subtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__Subtitle",
    componentId: "sc-e0cbc8e8-3"
})(_templateObject3(), styles/* theme.typography.subtitle7 */.rS.typography.subtitle7);
var TipWrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "SearchAddressNoti__TipWrap",
    componentId: "sc-e0cbc8e8-4"
})(_templateObject4(), styles/* theme.typography.caption1 */.rS.typography.caption1);
var Tip = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "SearchAddressNoti__Tip",
    componentId: "sc-e0cbc8e8-5"
})(_templateObject5());
var BulletWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__BulletWrap",
    componentId: "sc-e0cbc8e8-6"
})(_templateObject6());
var Example = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__Example",
    componentId: "sc-e0cbc8e8-7"
})(_templateObject7(), styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700]);
var Bullet = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressNoti__Bullet",
    componentId: "sc-e0cbc8e8-8"
})(_templateObject8(), styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary);
/* harmony default export */ var SearchAddress_SearchAddressNoti = (SearchAddressNoti);

// EXTERNAL MODULE: ./src/components/Divider/Divider.tsx
var Divider = __webpack_require__(73161);
// EXTERNAL MODULE: ./src/ui/Flag/index.ts + 1 modules
var Flag = __webpack_require__(93744);
;// CONCATENATED MODULE: ./src/ui/Icons/EmptyIcon.tsx


function EmptyIcon(props) {
    var _boxSize, _boxSize1, _fill, _fill1, _fill2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (_boxSize = props.boxSize) !== null && _boxSize !== void 0 ? _boxSize : "56",
        height: (_boxSize1 = props.boxSize) !== null && _boxSize1 !== void 0 ? _boxSize1 : "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28 54C42.3594 54 54 42.3594 54 28C54 13.6406 42.3594 2 28 2C13.6406 2 2 13.6406 2 28C2 42.3594 13.6406 54 28 54ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
                fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.2963 36.1498C29.3216 35.245 28.5602 34.4998 27.6212 34.4998C26.7329 34.4998 25.9969 35.245 25.9969 36.1498C25.9969 37.0546 26.7329 37.7998 27.6212 37.7998C28.5602 37.7998 29.3216 37.0546 29.2963 36.1498Z",
                fill: (_fill1 = props.fill) !== null && _fill1 !== void 0 ? _fill1 : "#121212"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.9969 18.0001L29.2969 17.9998L28.7469 32.2998L26.5469 32.2998L25.9969 18.0001Z",
                fill: (_fill2 = props.fill) !== null && _fill2 !== void 0 ? _fill2 : "#121212"
            })
        ]
    });
}
/* harmony default export */ var Icons_EmptyIcon = (EmptyIcon);

;// CONCATENATED MODULE: ./src/ui/SearchAddress/SearchAddressResult.tsx
function SearchAddressResult_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchAddressResult_templateObject() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    SearchAddressResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject1() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    SearchAddressResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject2() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  ",
        ";\n  & :first-child {\n    color: ",
        ";\n  }\n  & :last-child {\n    color: ",
        ";\n  }\n"
    ]);
    SearchAddressResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject3() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  font-weight: 700;\n"
    ]);
    SearchAddressResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject4() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    display: block;\n    width: 4px;\n  }\n  &::-webkit-scrollbar-thumb {\n    display: block;\n    background-color: ",
        ";\n    border-radius: 40px;\n  }\n"
    ]);
    SearchAddressResult_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject5() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  padding-right: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 78px;\n  cursor: pointer;\n"
    ]);
    SearchAddressResult_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject6() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 20px;\n"
    ]);
    SearchAddressResult_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject7() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 356px;\n  padding: 14px 0px;\n"
    ]);
    SearchAddressResult_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SearchAddressResult_templateObject8() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n"
    ]);
    SearchAddressResult_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  min-width: 328px;\n  width: 100%;\n  ",
        "\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 100px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = SearchAddressResult_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}







var MINIMUM_EXCEEDING_VALUE = 30;
function SearchAddressResult(param) {
    var page = param.page, value = param.value, totalNum = param.totalNum, addressList = param.addressList, handleSearchAddress = param.handleSearchAddress;
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        // 페이지 또는 인풋값이 변경될 경우 스크롤 위치 최상단으로 이동
        if (!ref.current) return;
        ref.current.scrollTo(0, 0);
    }, [
        page,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            totalNum !== 0 && totalNum > MINIMUM_EXCEEDING_VALUE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "“"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveText, {
                                                children: "".concat(value)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "”"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: " 검색한 결과 총 "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveText, {
                                                children: "".concat(totalNum)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "건 입니다."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "다음과 같이 검색하시면 정확한 결과가 검색됩니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "‘도로명+건물번호’, ‘지역명+번지’, ‘지역명+건물명(아파트명)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                h: "1px",
                                mt: "16px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressList, {
                        totalNum: totalNum,
                        ref: ref,
                        children: addressList.map(function(address, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressListItemWrap, {
                                        onClick: function() {
                                            return handleSearchAddress(address);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressListItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressWrap, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressBox, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* default */.Z, {
                                                                    flagColor: "mono",
                                                                    width: "44px",
                                                                    children: "도로명"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                                                    children: address.addrRoad
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressBox, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* default */.Z, {
                                                                    flagColor: "mono",
                                                                    width: "44px",
                                                                    children: "지번"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                                                    children: address.addrJibun
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostNum, {
                                                children: address.post5No
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        h: "1px",
                                        bgColor: styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100]
                                    })
                                ]
                            }, "address-".concat(address.addrRoad, "-").concat(idx));
                        })
                    })
                ]
            }),
            totalNum !== 0 && totalNum <= MINIMUM_EXCEEDING_VALUE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "“"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveText, {
                                        children: "".concat(value)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "”"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: " 검색한 결과 총 "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveText, {
                                        children: "".concat(totalNum)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "건 입니다."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                h: "1px",
                                mt: "16px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressList, {
                        totalNum: totalNum,
                        ref: ref,
                        children: addressList.map(function(address, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressListItemWrap, {
                                        onClick: function() {
                                            return handleSearchAddress(address);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressListItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressWrap, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressBox, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* default */.Z, {
                                                                    flagColor: "mono",
                                                                    width: "44px",
                                                                    children: "도로명"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                                                    children: address.addrRoad
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressBox, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* default */.Z, {
                                                                    flagColor: "mono",
                                                                    width: "44px",
                                                                    children: "지번"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                                                    children: address.addrJibun
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostNum, {
                                                children: address.post5No
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        h: "1px",
                                        bgColor: styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100]
                                    })
                                ]
                            }, "address-".concat(address.addrRoad, "-").concat(idx));
                        })
                    })
                ]
            }),
            totalNum === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "“"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveText, {
                                children: "".concat(value)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "”"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " 검색한 결과 총 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveText, {
                                children: "".concat(totalNum)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "건 입니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        h: "1px",
                        mt: "16px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSearchData, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_EmptyIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchTitle, {
                                children: "검색 결과가 없습니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchSubtitle, {
                                children: "정확한 주소를 확인하시고 다시 한번 검색해 주세요."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var DetailInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__DetailInfo",
    componentId: "sc-b989f2e2-0"
})(SearchAddressResult_templateObject());
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__Detail",
    componentId: "sc-b989f2e2-1"
})(SearchAddressResult_templateObject1(), styles/* theme.typography.body2 */.rS.typography.body2);
var SubDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__SubDetail",
    componentId: "sc-b989f2e2-2"
})(SearchAddressResult_templateObject2(), styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.neutral_colors.gray.600 */.rS.colors.neutral_colors.gray[600], styles/* theme.colors.accent_colors.blue.default */.rS.colors.accent_colors.blue["default"]);
var ActiveText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SearchAddressResult__ActiveText",
    componentId: "sc-b989f2e2-3"
})(SearchAddressResult_templateObject3());
var AddressList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__AddressList",
    componentId: "sc-b989f2e2-4"
})(SearchAddressResult_templateObject4(), function(param) {
    var totalNum = param.totalNum;
    return totalNum > MINIMUM_EXCEEDING_VALUE ? "337px" : "377px";
}, styles/* theme.colors.neutral_colors.gray.500 */.rS.colors.neutral_colors.gray[500]);
var AddressListItemWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__AddressListItemWrap",
    componentId: "sc-b989f2e2-5"
})(SearchAddressResult_templateObject5());
var AddressListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__AddressListItem",
    componentId: "sc-b989f2e2-6"
})(SearchAddressResult_templateObject6());
var AddressWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__AddressWrap",
    componentId: "sc-b989f2e2-7"
})(SearchAddressResult_templateObject7());
var AddressBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__AddressBox",
    componentId: "sc-b989f2e2-8"
})(SearchAddressResult_templateObject8());
var Address = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__Address",
    componentId: "sc-b989f2e2-9"
})(_templateObject9(), styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary);
var PostNum = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__PostNum",
    componentId: "sc-b989f2e2-10"
})(_templateObject10(), styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary);
var NoSearchData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__NoSearchData",
    componentId: "sc-b989f2e2-11"
})(_templateObject11());
var NoSearchTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__NoSearchTitle",
    componentId: "sc-b989f2e2-12"
})(_templateObject12(), styles/* theme.typography.body1 */.rS.typography.body1);
var NoSearchSubtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddressResult__NoSearchSubtitle",
    componentId: "sc-b989f2e2-13"
})(_templateObject13(), styles/* theme.typography.caption1 */.rS.typography.caption1, styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700]);
/* harmony default export */ var SearchAddress_SearchAddressResult = (SearchAddressResult);

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/di-container/axios.ts
var axios = __webpack_require__(43856);
// EXTERNAL MODULE: ../../shared/common/src/index.ts + 9 modules
var src = __webpack_require__(61462);
;// CONCATENATED MODULE: ./src/di-container/common/search-address/gateway/client.ts


var searchAddressGateway = function() {
    return {
        getSearchAddress: new src/* GetSearchAddressGateway */.CH(axios/* axios */.o),
        getSearchBlueprints: new src/* GetSearchBlueprintsGateway */.p9(axios/* axios */.o)
    };
};

;// CONCATENATED MODULE: ./src/feat-components/UntactConsultRequest/hooks/useSearchAddress.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function useSearchAddress() {
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(""), _value = ref2[0], _setValue = ref2[1]; // 인풋값과 결과값의 구분용 상태값
    var ref3 = (0,react.useState)("검색어를 입력해 주세요"), placeholder = ref3[0], setPlaceholder = ref3[1];
    var ref4 = (0,react.useState)(""), inputError = ref4[0], setInputError = ref4[1];
    var ref5 = (0,react.useState)(false), hasResult = ref5[0], setHasResult = ref5[1];
    var ref6 = (0,react.useState)(null), addressList = ref6[0], setAddressList = ref6[1];
    var ref7 = (0,react.useState)(0), totalNum = ref7[0], setTotalNum = ref7[1];
    var INPUT_LIMIT_LENGTH = 30;
    var SIZE = 15;
    var getSearchAddress = searchAddressGateway().getSearchAddress;
    var handlePage = (0,react.useCallback)(function(_page) {
        setPage(_page);
    }, []);
    var handleSearchInput = (0,react.useCallback)(function(e) {
        setValue(e.target.value);
    }, []);
    var handleSearchDelete = (0,react.useCallback)(function() {
        setValue("");
        setHasResult(false);
    }, []);
    var validationSearchInput = (0,react.useCallback)(function() {
        switch(true){
            case value.length === 0:
                return {
                    placeholder: "도로명주소, 건물명 또는 지번입력",
                    error: "검색어를 입력해 주세요."
                };
            case value.length === 1:
                return {
                    placeholder: "도로명주소, 건물명 또는 지번입력",
                    error: "검색어는 최소 2글자 이상 입력해 주세요."
                };
            case value.length > INPUT_LIMIT_LENGTH:
                return {
                    placeholder: "도로명주소, 건물명 또는 지번입력",
                    error: "검색어가 너무 깁니다."
                };
            default:
                return {
                    placeholder: "검색어를 입력해 주세요",
                    error: ""
                };
        }
    }, [
        value
    ]);
    var getAddress = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var currentPage, req, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currentPage = param.currentPage;
                        req = {
                            query: value,
                            page: currentPage || 1,
                            size: SIZE
                        };
                        _ctx.next = 4;
                        return getSearchAddress.exec(req);
                    case 4:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            setAddressList(res.data.content);
                            setTotalNum(res.data.totalElements);
                        } else {
                            setAddressList(null);
                            setTotalNum(0);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getSearchAddress,
        value
    ]);
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setInputError(validationSearchInput().error);
                        setPlaceholder(validationSearchInput().placeholder);
                        setPage(1);
                        _ctx.t0 = validationSearchInput().error;
                        if (_ctx.t0) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 8;
                        return getAddress({
                            currentPage: 1
                        });
                    case 8:
                        _setValue(value);
                        setHasResult(!validationSearchInput().error);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        validationSearchInput,
        getAddress,
        value
    ]);
    (0,react.useEffect)(function() {
        validationSearchInput().error || getAddress({
            currentPage: page || 1
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page
    ]);
    return {
        page: page,
        handlePage: handlePage,
        placeholder: placeholder,
        handleSearchInput: handleSearchInput,
        value: value,
        handleSearchDelete: handleSearchDelete,
        handleSubmit: handleSubmit,
        inputError: inputError,
        hasResult: hasResult,
        _value: _value,
        totalNum: totalNum,
        addressList: addressList,
        SIZE: SIZE
    };
}
/* harmony default export */ var hooks_useSearchAddress = (useSearchAddress);

;// CONCATENATED MODULE: ./src/ui/SearchAddress/SearchAddress.tsx
function SearchAddress_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchAddress_templateObject() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  margin-top: auto;\n"
    ]);
    SearchAddress_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject1() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  padding: 0px 40px 40px;\n  min-height: 586px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    SearchAddress_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject2() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    SearchAddress_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject3() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  width: 490px;\n  height: 48px;\n  position: relative;\n"
    ]);
    SearchAddress_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject4() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  margin-top: 8px;\n  margin-left: 20px;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    SearchAddress_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject5() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  border: none;\n  padding: 0px 76px 0px 20px;\n  margin: 0px;\n  background-color: ",
        ";\n  border-radius: 24px;\n  color: ",
        ";\n  ",
        ";\n  caret-color: ",
        ";\n  &::placeholder {\n    color: ",
        ";\n    ",
        ";\n  }\n"
    ]);
    SearchAddress_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject6() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    SearchAddress_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject7() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  background-color: transparent;\n  cursor: pointer;\n"
    ]);
    SearchAddress_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SearchAddress_templateObject8() {
    var data = SearchAddress_taggedTemplateLiteral([
        "\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  padding: 0px;\n  margin: 0px;\n  background-color: transparent;\n  cursor: pointer;\n"
    ]);
    SearchAddress_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










function SearchAddress(param) {
    var handleSearchAddress = param.handleSearchAddress;
    var ref = hooks_useSearchAddress(), page = ref.page, handlePage = ref.handlePage, placeholder = ref.placeholder, handleSearchInput = ref.handleSearchInput, value = ref.value, handleSearchDelete = ref.handleSearchDelete, handleSubmit = ref.handleSubmit, inputError = ref.inputError, hasResult = ref.hasResult, _value = ref._value, totalNum = ref.totalNum, addressList = ref.addressList, SIZE = ref.SIZE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchAddressWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchAddressContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchInputWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                                        placeholder: placeholder,
                                        onChange: handleSearchInput,
                                        value: value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchButtonWrap, {
                                        children: [
                                            value.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDeleteButton, {
                                                type: "button",
                                                onClick: handleSearchDelete,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SearchDelete16Icon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                                                type: "submit",
                                                onClick: handleSubmit,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_TopbarSearchIcon, {
                                                    boxSize: "32px"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            inputError !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError, {
                                children: inputError
                            })
                        ]
                    }),
                    hasResult ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAddress_SearchAddressResult, {
                        page: page,
                        value: _value,
                        totalNum: totalNum,
                        addressList: addressList,
                        handleSearchAddress: handleSearchAddress
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAddress_SearchAddressNoti, {})
                ]
            }),
            hasResult && totalNum > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardPagination/* default */.Z, {
                    page: page,
                    handlePage: handlePage,
                    value: _value,
                    totalPages: Math.ceil(totalNum / SIZE),
                    showPages: 10,
                    paginationType: "static",
                    hasFirstArrow: false,
                    hasLastArrow: false
                })
            })
        ]
    });
}
var PaginationWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddress__PaginationWrap",
    componentId: "sc-81233aab-0"
})(SearchAddress_templateObject());
var SearchAddressWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddress__SearchAddressWrap",
    componentId: "sc-81233aab-1"
})(SearchAddress_templateObject1());
var SearchAddressContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddress__SearchAddressContent",
    componentId: "sc-81233aab-2"
})(SearchAddress_templateObject2());
var SearchInputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddress__SearchInputWrap",
    componentId: "sc-81233aab-3"
})(SearchAddress_templateObject3());
var InputError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddress__InputError",
    componentId: "sc-81233aab-4"
})(SearchAddress_templateObject4(), styles/* theme.typography.caption1 */.rS.typography.caption1, styles/* theme.colors.accent_colors.error */.rS.colors.accent_colors.error);
var SearchInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "SearchAddress__SearchInput",
    componentId: "sc-81233aab-5"
})(SearchAddress_templateObject5(), styles/* theme.colors.neutral_colors.gray.50 */.rS.colors.neutral_colors.gray[50], styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary, styles/* theme.typography.body2 */.rS.typography.body2, styles/* theme.colors.accent_colors.red.default */.rS.colors.accent_colors.red["default"], styles/* theme.colors.neutral_colors.gray.500 */.rS.colors.neutral_colors.gray[500], styles/* theme.typography.body2 */.rS.typography.body2);
var SearchButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchAddress__SearchButtonWrap",
    componentId: "sc-81233aab-6"
})(SearchAddress_templateObject6());
var SearchDeleteButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SearchAddress__SearchDeleteButton",
    componentId: "sc-81233aab-7"
})(SearchAddress_templateObject7());
var SearchButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SearchAddress__SearchButton",
    componentId: "sc-81233aab-8"
})(SearchAddress_templateObject8());
/* harmony default export */ var SearchAddress_SearchAddress = (SearchAddress);

;// CONCATENATED MODULE: ./src/ui/SearchAddress/index.ts



/***/ })

}]);